import React from "react";
import "./Switch.css";

const Switch = ({ isOn, handleToggle, index, disabled = false }) => {
  return (
    <div className={`switch ${disabled ? 'disabled' : ''}`}>
      <input
        checked={isOn}
        onChange={disabled ? () => {} : handleToggle}
        className="react-switch-checkbox"
        id={`react-switch-new-${index}`}
        type="checkbox"
        disabled={disabled}
      />
      <label className="react-switch-label" htmlFor={`react-switch-new-${index}`}>
        <span className={`react-switch-button ${index}`} />
      </label>
    </div>
  );
};

export default Switch;
